import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import SignsCustomSoftware2 from '../../../components/Satellites/customSoftware/SignsCustomSoftware/SignsCustomSoftware2/SignsCustomSoftware2';
import SignsCustomSoftware3 from '../../../components/Satellites/customSoftware/SignsCustomSoftware/SignsCustomSoftware3/SignsCustomSoftware3';
import SignsCustomSoftware4 from '../../../components/Satellites/customSoftware/SignsCustomSoftware/SignsCustomSoftware4/SignsCustomSoftware4';
import SignsCustomSoftware5 from '../../../components/Satellites/customSoftware/SignsCustomSoftware/SignsCustomSoftware5/SignsCustomSoftware5';
import SignsCustomSoftware6 from '../../../components/Satellites/customSoftware/SignsCustomSoftware/SignsCustomSoftware6/SignsCustomSoftware6';
import SignsCustomSoftware7 from '../../../components/Satellites/customSoftware/SignsCustomSoftware/SignsCustomSoftware7/SignsCustomSoftware7';

class SignsCustomSoftware extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="signs_custom_software" />
        <ServiceBanner {...this.props} page="signsCustomSoftware" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <SignsCustomSoftware2 {...this.props} />
        <SignsCustomSoftware3 {...this.props} />
        <SignsCustomSoftware4 {...this.props} />
        <SignsCustomSoftware5 {...this.props} />
        <SignsCustomSoftware6 {...this.props} />
        <SignsCustomSoftware7 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(SignsCustomSoftware);
